import { getLocalTimeZone, today } from "@internationalized/date";
import { FUNNEL_QUESTIONNAIRE_ELIGIBILITY } from "src/constants/misc";
import envVariables from "src/lib/envVariables";
import type { CustomQuestionnaireFilterAnswerOptions } from "src/state/QuestionnaireCubit/QuestionnaireState";
import { EligibilityQuestionId } from "./EligibilityQuestionnaireFields";
import { factoryCampaignInstances } from "./SignupCustomCampaignGenericInstances";

export function getReleaseDateExclusions(): CustomQuestionnaireFilterAnswerOptions[] {
  // Unreleased campaigns stay selectable outside production so QA can test them before launch.
  if (envVariables.APP_ENV !== "production") {
    return [];
  }

  const todayDate = today(getLocalTimeZone());
  const employerExclusions: string[] = [];
  const healthPlanExclusions: string[] = [];

  for (const campaign of factoryCampaignInstances()) {
    const releaseDate = campaign.factoryOptions.availabilityChecks?.releaseDate;
    if (!releaseDate) {
      continue;
    }

    const isNotYetReleased = releaseDate.compare(todayDate) > 0;
    if (!isNotYetReleased) {
      continue;
    }

    const answerOverrides =
      campaign.factoryOptions.answerOverrides?.[
        FUNNEL_QUESTIONNAIRE_ELIGIBILITY
      ];
    if (!answerOverrides) {
      continue;
    }

    for (const override of answerOverrides) {
      if (
        override.questionId === EligibilityQuestionId.employer &&
        override.fieldType === "choice" &&
        typeof override.fieldValue === "object" &&
        "choiceId" in override.fieldValue
      ) {
        employerExclusions.push(override.fieldValue.choiceId as string);
      }

      if (
        override.questionId === EligibilityQuestionId.healthPlan &&
        override.fieldType === "choice" &&
        typeof override.fieldValue === "object" &&
        "choiceId" in override.fieldValue
      ) {
        healthPlanExclusions.push(override.fieldValue.choiceId as string);
      }
    }
  }

  const filters: CustomQuestionnaireFilterAnswerOptions[] = [];

  if (employerExclusions.length > 0) {
    filters.push({
      questionId: EligibilityQuestionId.employer,
      excludeOptions: employerExclusions
    });
  }

  if (healthPlanExclusions.length > 0) {
    filters.push({
      questionId: EligibilityQuestionId.healthPlan,
      excludeOptions: healthPlanExclusions
    });
  }

  return filters;
}
